export default __webpack_public_path__ + "static/media/01_02.129a65ca.jpg";